import { ReactElement } from 'react'

import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

import { updateTriggeredAlert } from 'api/Cerebro/orgScoped/alertsApi'
import { useCerebroApiRequest } from 'hooks'
import { alertUrl } from 'routing/urls'
import { TriggeredAlert } from 'types'

interface Props {
    triggeredAlert: TriggeredAlert
}

const AlertLink = ({ triggeredAlert }: Props): ReactElement => {
    const navigate = useNavigate()
    const makeCerebroApiRequest = useCerebroApiRequest()

    const handleDismissTriggeredAlert = async (): Promise<void> => {
        await makeCerebroApiRequest({
            request: updateTriggeredAlert(triggeredAlert.id, {
                status: 'read',
            }),
            onRequestSuccess: () => {
                navigate(alertUrl(triggeredAlert.alert_configuration))
            },
        })
    }

    return (
        <Button
            type="link"
            onClick={handleDismissTriggeredAlert}
            style={{ paddingLeft: 0, paddingRight: 0 }}
        >
            {triggeredAlert.alert_configuration.name}
        </Button>
    )
}

export default AlertLink
